import { render, staticRenderFns } from "./AWalletIcon.vue?vue&type=template&id=8c6328d0&"
import script from "./AWalletIcon.vue?vue&type=script&lang=js&"
export * from "./AWalletIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports